/* global edacpFullSiteScanApp */
import { settings } from './settings';
import { init as initFullSiteScanUI } from './fullSiteScanUI';
import { init as initCheckPages } from './checkPages';

if ( settings.JS_SCAN_ENABLED ) {
	window.addEventListener( 'DOMContentLoaded', () => {
		if ( edacpFullSiteScanApp.mode === 'full-site-scan' ) {
			initCheckPages();
			initFullSiteScanUI();
		}
	} );
}
